
export class CurrentPlaylist
{
  track_list : any[];
}